export default __webpack_public_path__ + "static/A_0087_3-622931bd67dd295b7e40803cc92ed84d.mp4";